<div class="margin-all-area">
  <div class="teamOfficeSection">
    <div class="teamOfficeBody">
      <div class="text-left" [innerHTML]="htmlText | safeHtml">
      </div>
    </div>
  </div>
</div>
<div class="loader-body" *ngIf="showSpinner">
  <div class="lds-ripple"><div></div><div></div></div>
</div>
